import { useState, useEffect } from 'react'
import { appFetchMinimumAPI } from '../services/minimum'
import { useTranslation } from 'react-i18next'

export default function UseMinimum() {
  const { t } = useTranslation()
  const [data, setData] = useState(null)

  useEffect(() => {
    const getTranslation = async () => {
      const result = await appFetchMinimumAPI()
      if (!result) return

      const testNewData = JSON.parse(
        result?.appFetchRemoteConfigByKey?.payload?.value ?? '[]',
      )

      const newData = testNewData.map((d) => ({
        value: d.value,
        label: t(d.label),
      }))

      setData(newData)
    }

    getTranslation()
  }, [t]) // ✅ ใส่ t ใน dependency

  return data
}